export default import.meta.ROLLUP_FILE_URL_VvUzsrNz5A2Shdppcnfjpg